import { CustomDropdown } from 'components/shared/CustomDropdown';
import { getLocalStorage, isValidUser } from 'helpers/Helper';
import { getDecodedAccessToken } from 'helpers/TokenHelper';
import { IThresholdModel } from 'models/Threshold.Model';
import { IUpdatethresholdModel } from 'models/UpdateThreshold.Model';
import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, Col, Container, Row } from 'reactstrap';
import MasterService from 'services/Master.Service';
import ProductTypeService from 'services/ProductType.Service';
import QuestionnaireTemplateService from 'services/QuestionnaireTemplate.Service';
import { QuestionnaireItem } from './QuestionnaireItem/QuestionnaireItem';
import { CustomToaster } from 'components/shared/CustomToaster';
import CustomLoader from 'components/Common/CustomLoader';

function ProductThreshold() {

    const [successToast, setSucessToast] = useState(false);
    const [warningToast, setWarningToast] = useState(false);
    const [ProductList, setProductList] = useState<Array<any>>([])
    const [ProductTypevalue, setProductTypevalue] = useState<any>(0);
    const [catergoryValue, setCategoryValue] = useState<any>(0);
    const [OsTypevalue, setOsTypevalue] = useState<any>(0);
    const [OsType, setOsType] = useState<Array<any>>([]);
    const [Categories, setCategories] = useState<Array<any>>([]);
    const [Threshold, setThreshold] = useState<Array<IThresholdModel>>([]);
    const [result, setResult] = useState<Array<IUpdatethresholdModel>>([]);
    const [savebtndisable, setSavebtndisable] = useState<boolean>();

    useEffect(() => {
        const ProductTypeServicesData = () => {
            screenRefresh();
            ProductTypeService.GetList().then(res => {
                setProductList(res.data);
            });
        }
        ProductTypeServicesData();
        isValidUser(getDecodedAccessToken(getLocalStorage().Token));

        return () => {
            //your cleanup code codes here
            screenRefresh();
        };
    }, [])

    const GetOSTypebyGadgetId = (productTypeId: any) => {
        setOsType([]);
        setCategories([]);
        setOsTypevalue(0);
        setCategoryValue(0);
        setProductTypevalue(productTypeId);
        setResult([]);
        setThreshold([]);
        MasterService.GetOSTypebyGadgetId(productTypeId).then(res => {
            setOsType(res.data);
        });
    }

    const GetCategorybyOSTypeGadgetId = (osTypeId: any) => {
        setCategories([]);
        setCategoryValue(0);
        setOsTypevalue(osTypeId);
        setResult([]);
        setThreshold([]);
        MasterService.GetCategorybyOSTypeGadgetId(ProductTypevalue, osTypeId).then(res => {
            setCategories(res.data);
        });
    }

    const GetQuestionaireTemplateByCategory = (categoryId: any) => {
        setCategoryValue(categoryId);
        setResult([]);
        setThreshold([0 as any]);
        if (OsTypevalue > 0 && categoryId > 0) {
            QuestionnaireTemplateService.GetQuestionaireTemplateByCategory(ProductTypevalue, OsTypevalue, categoryId).then(res => {
                setThreshold(res.data);
                bindResponseData(res.data);
            });
        }
    }

    const SubmitOrUpdateTemplate = () => {
        GetQuestionaireTemplateByCategory([]);
        setSavebtndisable(false);
        QuestionnaireTemplateService.SubmitOrUpdateTemplate(result).then((res) => {
            if (res.status === 200) {
                setResult([]);
                setThreshold([]);
                bindResponseData([]);
                setSucessToast(true);
                setSavebtndisable(false);
            }
        }).catch(e => {
            console.log(e);
        })
    }

    //threshold Update function
    const thresholdUpdate = (item: IThresholdModel, value: any) => {
        setSavebtndisable(true);
        let Identifier = item.Identifier;
        let fIndex = result.findIndex(it => it.identifier === Identifier);
        const tempResult: IUpdatethresholdModel = bindData(item, value);
        if (fIndex === -1) {
            result.push(tempResult);
        }
        else {
            result[fIndex] = tempResult;
        }
        setResult(result);
    }

    const bindResponseData = (data: Array<IThresholdModel>) => {
        for (const res of data) {
            const tempResult: IUpdatethresholdModel = bindData(res, res.Threshold);
            result.push(tempResult);
            setResult(result);
        }
    }

    const bindData = (item: IThresholdModel, value: any): IUpdatethresholdModel => {
        return {
            id: item.Id,
            created: item.Created,
            createdBy: item.CreatedBy,
            CategoryId: item.CategoryId,
            active: item.Active,
            modified: item.Modified,
            modifiedBy: item.ModifiedBy,
            validationErrors: {},
            productTypeId: item.ProductTypeId,
            questionnaireTypeId: item.QuestionnaireTypeId,
            questionnaireTypeName: item.QuestionnaireTypeName,
            osTypeId: item.OSTypeId,
            modelVariantId: item.ModelVariantId,
            identifier: item.Identifier,
            parentId: item.ParentId,
            name: item.Name,
            displayName: item.DisplayName,
            enumName: item.EnumName,
            SubHeading: item.SubHeading,
            type: item.Type,
            answerType: item.AnswerType,
            threshold: value,
            rowOrder: item.RowOrder,
            displayInList: item.DisplayInList,
            thresholdLevel: item.ThresholdLevel,
            enabled: item.Enabled,
            thumbnailPath: item.ThumbnailPath,
            isEditable: item.IsEditable,
        };
    }

    const screenRefresh = () => {
        // window.location.reload();
        setCategories([]);
        setThreshold([]);
        setOsType([]);
        setProductTypevalue(0);
        setOsTypevalue(0);
        setCategoryValue(0);
    }

    const handleCancel = () => {
        if (ProductTypevalue > 0 && OsTypevalue > 0 && catergoryValue > 0) {
            GetQuestionaireTemplateByCategory(catergoryValue);
            setSavebtndisable(false);
        }
    };
    
    return (
        <div className="page-content">
            <Container fluid>
                <div>
                    <h5 className="d-flex mb-3 fw-semibold text-dofy dofy-admin-font-md" style={{ whiteSpace: "nowrap" }}>PRODUCT THRESHOLD</h5>
                </div>
                {/* <Row >
                    <Col lg="12" xl="12" xs="12">
                        <Link to={'/HomePage'}><i className='fa fa-home'></i></Link> PRODUCT THRESHOLD PAGE
                    </Col>
                </Row> */}
                <Card>
                    <CardBody>
                        <Row>
                            <Col size="12">
                                <Row>
                                    <Col xs="12" md="4">
                                        <CustomDropdown label={"Gadget"} data={ProductList} value={ProductTypevalue} onChange={(e) => GetOSTypebyGadgetId(e.target.value)} id={undefined} error={undefined} displayField='DisplayName' valueField='Id' />
                                    </Col>
                                    <Col xs="12" md="4">
                                        <CustomDropdown label={"OsType"} data={OsType} value={OsTypevalue} onChange={(e) => GetCategorybyOSTypeGadgetId(e.target.value)} disabled={!(OsType.length > 0)} id={undefined} error={undefined} displayField='DisplayName' valueField='Id' />
                                    </Col>
                                    <Col xs="12" md="3">
                                        <CustomDropdown label={"Categories"} data={Categories} value={catergoryValue} onChange={(e) => GetQuestionaireTemplateByCategory(e.target.value)} disabled={!(Categories.length > 0)} id={undefined} error={undefined} displayField='DisplayName' valueField='Id' />
                                    </Col>
                                    <Col xs="12" md="1" className='text-center' style={{ marginTop: "38px" }}>
                                        <Button onClick={() => screenRefresh()}> Reset</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

                {Threshold[0] == (0 as any) ?
                    <CustomLoader isOpen={true} />
                    :
                    Threshold.length > 0 ?
                        <Row>
                            <Col lg='12' xs='12' md='12' className=''>
                                <QuestionnaireItem data={Threshold} onChangeHandler={thresholdUpdate}></QuestionnaireItem>
                            </Col>
                            <Col size='12' className='text-end mb-2'>
                                <Button className='' onClick={handleCancel}>Cancel</Button>
                                <Button className='m-3' disabled={!savebtndisable} color='success' onClick={() => SubmitOrUpdateTemplate()}>Save</Button>
                            </Col>
                        </Row>
                        :
                        <Row>
                            <Col className='text-center mt-4'>
                                <Card>
                                    <CardBody className='ion-text-center'>
                                        <i className='bx bxs-devices dofy-admin-font-xl text-danger'></i>
                                        <h6 className='text-danger'>Choose criteria to view product threshold.</h6>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                }
                <CustomToaster message={"Your screen have been saved."} color={'text-success'} toast={successToast} setToast={setSucessToast} />
                <CustomToaster message={"Heading Value Should be equal to 100"} color={'text-danger'} toast={warningToast} setToast={setWarningToast} />
            </Container>
        </div>
    )
}

export default ProductThreshold